import { TaskRoute } from '@services/api';
import { Button, Card, Space } from 'antd';

interface Props {
  routes: TaskRoute[];
  onSelect: (routeKey: string) => void;
  disabled?: boolean;
}

const cardStyle: React.CSSProperties = {
  boxShadow: 'none',
  border: 'none',
  borderRadius: 0,
  display: 'flex',
  justifyContent: 'center',
};

const cardBodyStyle: React.CSSProperties = {
  padding: 0,
  display: 'flex',
  justifyContent: 'center',
};

export default function TaskRouteButtons({ routes, onSelect, disabled }: Props) {
  return (
    <Card bordered={false} bodyStyle={cardBodyStyle} style={cardStyle}>
      <Space wrap size={[16, 16]} align="center" style={{ justifyContent: 'center' }}>
        {routes.map((r) => (
          <Button
            key={r.key}
            type="primary"
            size="large"
            disabled={disabled}
            onClick={() => onSelect(r.key)}
          >
            {r.value}
          </Button>
        ))}
      </Space>
    </Card>
  );
}
